/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignFixedWingLineCrewByDateRequest } from '../../models/assign-fixed-wing-line-crew-by-date-request';
import { FixedWingLineAssignmentResponse } from '../../models/fixed-wing-line-assignment-response';

export interface AssignFixedWingLineCrewByDate$Params {
      body: AssignFixedWingLineCrewByDateRequest
}

export function assignFixedWingLineCrewByDate(http: HttpClient, rootUrl: string, params: AssignFixedWingLineCrewByDate$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingLineAssignmentResponse>> {
  const rb = new RequestBuilder(rootUrl, assignFixedWingLineCrewByDate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingLineAssignmentResponse>;
    })
  );
}

assignFixedWingLineCrewByDate.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/line-assignments';
